<xemex-page-header
  [title]="'sidebarMenu.locations' | translate"
  [breadcrumbs]="[{ label: 'sidebarMenu.home' | translate, routerLink: '/' }, { label: 'sidebarMenu.locations' | translate }]"
  [withBackground]="false"
></xemex-page-header>

<xemex-page-body>
  <xemex-table
    [data]="tableData()"
    [columns]="columns"
    [loading]="locationStore.isLoading()"
    [totalCount]="totalCount()"
    [rowLink]="rowLink"
    (pageChange)="onPageChange($event)"
  >
    <xemex-table-filter-bar
      [filterGroups]="filterGroups()"
      [initialFilters]="initialFilters()"
      [searchPlaceholder]="'locations.filter.placeholderAll' | translate"
      (searchChange)="onSearchChange($event)"
      (filterChange)="onFilterChange($event)"
    >
      <xemex-outlined-button
        actions
        type="button"
        icon="upload_file"
        (click)="openImportDialog()"
      >
        {{ 'locations.addDialog.btnImport' | translate }}
      </xemex-outlined-button>
      <xemex-filled-button
        actions
        type="button"
        icon="add"
        (click)="openAddDialog()"
      >
        {{ 'locations.addDialog.btnAdd' | translate }}
      </xemex-filled-button>
    </xemex-table-filter-bar>
  </xemex-table>
</xemex-page-body>
